import { ChangeEvent, useCallback } from 'react';
import { useTranslations } from 'next-intl';
import World from '@engineering/icons/world';
import { Ui } from '@silvertours/front-shared';
import { Runtime } from '@silvertours/front-entities';
import { DEDICATED_SITES, FIELD_NAMES } from './constants';
import { getMarketRedirectUrl } from './redirect';
import { Section } from './Section';

/**
 * Country selection inside the regional settings. Unlike the currency, switching
 * the market is a redirect to that market's dedicated site (the landing pages
 * are split across domains), so changing it navigates away.
 */
const MarketField = () => {
  const t = useTranslations(
    'features.navigationLegacy.navigation.header.regionalSettings',
  );
  const { market } = Runtime.useLocale();

  const handleChange = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
    window.location.assign(
      getMarketRedirectUrl(event.target.value, window.location),
    );
  }, []);

  return (
    <Section
      icon={<World />}
      label={t('market.label')}
      description={t('market.description')}
    >
      <Ui.Dropdown
        id={FIELD_NAMES.REDIRECT}
        label={t('market.label')}
        hideLabel
        value={market}
        onChange={handleChange}
        options={DEDICATED_SITES.map(value => ({
          // Used translations:
          // - regionalSettings.market.value.CH
          // - regionalSettings.market.value.DE
          // - regionalSettings.market.value.FR
          label: t(`market.value.${value}`),
          value,
        }))}
      />
    </Section>
  );
};

export { MarketField };
